import {useCallback} from 'react';
import {useSelector} from 'react-redux';
import {sendEmailLeads, sendWhatsAppLeads, sendSmsLeads} from '../../../../redux/publish/publishActions';
import {TState} from '../../../../redux/store.type';
import {UseSendProps} from '../../../../hooks/sendHooks.types';

export const useLeadSend = ({whatsappData, emailData, smsData, show}: UseSendProps) => {
    const leads = useSelector((state: TState) => state.branding.leads);

    const handleSend = useCallback(async (type: string, trialRecipients?: string[]) => {
        try {
            switch (type) {
                case 'whatsapp':
                    await sendWhatsAppLeads({
                        ...whatsappData, 
                        ...(trialRecipients ? {trialRecipients} : {leads})
                    });
                    break;
                case 'email':
                    await sendEmailLeads({
                        ...emailData, 
                        ...(trialRecipients ? {trialRecipients} : {leads})
                    });
                    break;
                case 'sms':
                    await sendSmsLeads({
                        ...smsData, 
                        ...(trialRecipients ? {trialRecipients} : {leads})
                    });
                    break;
            }
            return true;

        } catch (error) {
            console.error('Failed to send leads:', error);
            show.close();
            return false;
        }
    }, [whatsappData, emailData, smsData, leads, show]);

    return {handleSend};
};
